export const guessImageFileTypeFromFileName = (filename: string | undefined) => {
  if (!filename) return 'image/jpeg'

  const re = /(?:\.([^.]+))?$/
  const imageType = re.exec(filename)?.[1] || 'jpeg'
  return `image/${imageType}`
}

export const getFileSizeFromUrl = async (url: string): Promise<number> => {
  const response = await fetch(url)
  const fileBlob = await response.blob()
  return fileBlob.size
}

/**
 * Get file icon emoji based on MIME type
 * @param mimeType - The MIME type of the file
 * @returns Emoji icon representing the file type
 */
export const getFileIconFromMimeType = (mimeType: string): string => {
  if (mimeType?.startsWith('image/')) return '🖼️'
  if (mimeType?.startsWith('video/')) return '🎥'
  if (mimeType?.startsWith('audio/')) return '🎵'
  if (mimeType?.includes('pdf')) return '📄'
  if (mimeType?.includes('word') || mimeType?.includes('document')) return '📝'
  if (mimeType?.includes('sheet') || mimeType?.includes('excel')) return '📊'
  if (mimeType?.includes('presentation') || mimeType?.includes('powerpoint')) return '📽️'
  if (mimeType?.includes('zip') || mimeType?.includes('rar') || mimeType?.includes('archive'))
    return '🗜️'
  return '📎'
}
